import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as adminAction from "../redux/actions/adminActions";
import * as authAction from "../redux/actions/authAction";
import { getToken, removeToken } from "../utils/setAuthToken";

const AuthHandler = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { getPermission, getSubadminPermissionFlags } = bindActionCreators(adminAction, dispatch);
    const { loadUser } = bindActionCreators(authAction, dispatch);
    const { allowedRoutes } = useSelector((state) => state.admin);
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const hasFetchedPermissions = useRef(false);

    useEffect(() => {
        const token = getToken();
        if (token) {
            loadUser();  // Load user even if token is present
        } else if ((localStorage.tokenAdmin === undefined || localStorage.tokenAdmin === null) || (sessionStorage.tokenAdmin === undefined || sessionStorage.tokenAdmin === null)) {
            removeToken();
            navigate("/login");
        }
        else {
            removeToken(); // Ensure token is properly cleared
            navigate("/login"); // Redirect to login if no token
        }
    }, []);


    useEffect(() => {
        const token = getToken();
        if (!token && !isAuthenticated && !user) {
            navigate("/login"); // Redirect to login page
        } else if (isAuthenticated && allowedRoutes.length === 0) {
            getPermission();
            getSubadminPermissionFlags();
        } else if (isAuthenticated && allowedRoutes.length > 0 && (location.pathname === "/login" || location.pathname === "/")) {
            navigate("/dashboard", { replace: true });
        }

    }, [isAuthenticated, user, allowedRoutes, location.pathname]);

    return null;
};

export default AuthHandler;
